import { render, staticRenderFns } from "./plan-item-3.vue?vue&type=template&id=4f84ff36&scoped=true&"
import script from "./plan-item-3.vue?vue&type=script&lang=js&"
export * from "./plan-item-3.vue?vue&type=script&lang=js&"
import style0 from "./plan-item-3.vue?vue&type=style&index=0&id=4f84ff36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f84ff36",
  null
  
)

export default component.exports